import { images } from "../constants";

const testimonials = [  
    { 
        id: 1,
        image: images.testimonial1, 
        name: 'Daniel Carter', 
        title: 'Marketing Manager',
        content: 'The event was incredibly well-organized and packed with valuable insights. From the keynote speakers to breakout sessions, everything contributed to a highly productive experience. I gained practical knowledge I can immediately apply.'
    }, 
    { 
        id: 2,
        image: images.testimonial2, 
        name: 'Olivia Brooks', 
        title: 'Software Engineer',
        content: 'This conference was truly empowering. The sessions were informative, and the networking was fantastic. I connected with so many professionals who share my passion for innovation and growth.'
    },
    { 
        id: 3,
        image: images.testimonial3, 
        name: 'Michael Nguyen', 
        title: 'Project Manager',
        content: 'A great blend of inspiration and actionable content. I especially appreciated the focus on real-world challenges and how to overcome them. It’s definitely one of the best events I’ve attended recently.'
    },
];

export default testimonials;